import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiUpdateQuestionChangeStrategy } from '../../../../bases';
import { FillInBlankDescription } from '../components';
import { AiChangeType } from '../../../../../../../ai';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankUpdateQuestionStrategy = /*#__PURE__*/function (_AiUpdateQuestionChan) {
  _inherits(FillInBlankUpdateQuestionStrategy, _AiUpdateQuestionChan);

  var _super = _createSuper(FillInBlankUpdateQuestionStrategy);

  function FillInBlankUpdateQuestionStrategy(context) {
    _classCallCheck(this, FillInBlankUpdateQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(FillInBlankUpdateQuestionStrategy, [{
    key: "renderAnswers",
    value: function renderAnswers() {
      var _after$index;

      var before = this.context.before;
      var after = this.context.after;
      var changeType = this.context.changeType;
      var descriptionToDisplay = changeType === AiChangeType.Delete ? before === null || before === void 0 ? void 0 : before.description : after === null || after === void 0 ? void 0 : after.description;
      return /*#__PURE__*/_jsx(FillInBlankDescription, {
        description: descriptionToDisplay !== null && descriptionToDisplay !== void 0 ? descriptionToDisplay : '',
        beforeQuestion: before,
        afterQuestion: after,
        changeType: changeType,
        startQuestionIndex: (_after$index = after === null || after === void 0 ? void 0 : after.index) !== null && _after$index !== void 0 ? _after$index : 1
      });
    }
  }]);

  return FillInBlankUpdateQuestionStrategy;
}(AiUpdateQuestionChangeStrategy);